import { bind } from './input'

$(() => {
  bind()
})
